import Collaction from "./Collaction";

export default Collaction
